import { defineSlotRecipe } from "@pandacss/dev";

export const aromaNavButton = defineSlotRecipe({
  slots: ["root", "badge"],
  className: "aroma-nav-button",
  jsx: ["NavButton"],
  base: {
    root: {
      position: "relative",

      _active: {
        bgColor: "transparent !important",
        '&[data-active="true"]': {
          bgColor: "background.neutral.reverse.subtle !important",

          _hover: {
            bgColor: "background.brand.bolder-hover !important",
          },
        },
      },

      _focus: {
        bgColor: "transparent !important",
        '&[data-active="true"]': {
          bgColor: "background.neutral.reverse.subtle !important",
        },
      },

      shadow: {
        _focus: "effect.focus-ring.brand",
      },

      _expanded: {
        bgColor: "background.neutral.reverse.subtle !important",

        _hover: {
          bgColor: "background.brand.bolder-hover !important",
        },
      },
    },

    badge: {
      position: "absolute",
      top: "3px",
      right: "3px",
    },
  },
  variants: {
    hierarchy: {
      primary: {
        root: {
          color: "content.brand.reverse.bold !important",
          _active: {
            color: "content.neutral.reverse.bold !important",
          },
        },
      },
      secondary: {
        root: {
          bgColor: "background.brand.subtle",
          color: "background.brand.bolder !important",

          _hover: {
            color: "background.brand.subtle !important",
          },

          _active: {
            color: "background.brand.subtle !important",
            '&[data-active="true"]': {
              color: "background.brand.subtle !important",

              _hover: {
                color: "background.brand.subtle !important",
              },
            },
          },

          _focus: {
            color: "background.brand.subtle !important",
            '&[data-active="true"]': {
              color: "background.brand.subtle !important",
            },
          },

          _expanded: {
            color: "background.brand.subtle !important",

            _hover: {
              color: "background.brand.subtle !important",
            },
          },
        },
      },
    },
  },
  defaultVariants: {
    hierarchy: "primary",
  },
});
